export class NewPassword {

    UserToken : string;
    OrganisationID : number;
    Password : string;

    WasSuccessful : string;
    Exception : string;
}
